<template>
    <div class="right-navigation">
        <ul class="nav-ul">
             <li class="nav-li-item nav-li-item-1">
                <span class="item-icon icon-image" @click="eleccpower"></span>
                <h6 class="item-label"><span>电费E贷</span></h6>
            </li>
            <li class="nav-li-item nav-li-item-2" @click="pingan">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>平安银行<br />票据贴现</span></h6>
            </li>
            <li class="nav-li-item nav-li-item-3">
                <router-link :to="{ path: '/houseValuation' }">
                    <span class="item-icon icon-image"></span>
                    <h6 class="item-label"><span>房产估值</span></h6>
                </router-link>
            </li>
            <!-- <router-link to="/helpCenter">
                <li class="nav-li-item nav-li-item-1">
                    <span class="item-icon icon-image"></span>
                    <h6 class="item-label"><span>帮助中心</span></h6>
                </li>
            </router-link>
            <li class="nav-li-item nav-li-item-2" @mousemove="telephoeShow = true" @mouseleave="telephoeShow = false">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>电话咨询</span></h6>
                <div class="telephone-num" v-if="telephoeShow">
                    <p class="num">0931-8101239</p>
                    <p class="num">0931-8101279</p>
                    <p class="text">工作日接听电话</p>
                </div>
            </li>
            <router-link to="/systemNotice">
                <li class="nav-li-item nav-li-item-5">
                    <span class="item-icon icon-image"></span>
                    <h6 class="item-label"><span>系统公告</span></h6>
                </li>
            </router-link>
            <li class="nav-li-item nav-li-item-6" @mousemove="xcxCodeShow = true" @mouseleave="xcxCodeShow = false">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>小程序</span></h6>
                <div class="quick-mark" v-if="xcxCodeShow">
                    <img :src="xcxCodeImg" alt="小程序" />
                </div>
            </li> -->
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            telephoeShow: false,
            QRcodeShow: false,
            xcxCodeShow: false
        }
    },
    methods:{
      pingan(){
        window.open('https://openbank.pingan.com/brcp/openbank/openapi/h5/index.html#/note-platform/RzY2NjQ=/home')
      },
      eleccpower(){
          this.$router.push({
              path: "/productDetailsdl",
              query: {
                  id: "B7d2fd47e54147",
              },
          });

      }
    }
}
</script>

<style lang="scss" scoped>
.right-navigation {
    position: absolute;
    width: 100px;
    // height: 462px;
    z-index: 999;
    top: 50%;
    right: 0px;
    border-radius: 8px;
    margin-top: -120px;
    padding: 20px 0;
    // border: 1px solid #0090FF;
    background-color: #fff;
    box-shadow: 0px 2px 5px #ccc;
    .nav-li-item {
        position: relative;
        color: #000;
        // height: 80px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 0;

        > a {
            text-align: center;    
        }

        .item-icon {
            display: inline-block;
            width: 40px;
            height: 40px;
            margin-bottom: 8px;
        }

        .item-label > span {
            
        }
        h6{
          font-size: 16px;
          text-align: center;
          color: #333;
          line-height: 20px;
        }

        &.nav-li-item-1 .item-icon {
            background: url('./../assets/xyd/index/icon-08.png') no-repeat center center;
            background-size: 40px 40px;
        }
        &.nav-li-item-2 .item-icon {
            background: url('./../assets/xyd/index/icon-09.png') no-repeat center center;
            background-size: 40px 40px;
        }
        &.nav-li-item-3 .item-icon {
            background: url('./../assets/xyd/index/icon-10.png') no-repeat center center;
            background-size: 40px 40px;
        }

    }

    .telephone-num {
        position: absolute;
        top: 0;
        left: 70px;
        width: 180px;
        background: #fff;
        border: 1px solid #0090FF;
        padding: 10px;
        border-radius: 5px;
        text-align: center;
        cursor: default;

        .num {
            font-size: 24px;
            color: #0090FF;
            line-height: 34px;
        }
        .text {
            font-size: 14px;
            color: #818181;
        }
    }

    .quick-mark {
        position: absolute;
        top: 0;
        left: 70px;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #0090FF;
        background-color: #fff;

        img {
            width: 137px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LeftNav.vue